import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { FinanceDtoKeysEnum } from '@zaoblako/shared/modules/finance/enums/finance-dto-keys.enum';
import { nonEmptyStringSchema } from '@zaoblako/shared/modules/serde/schemas/non-empty-string.schema';
import { BalanceReportFormatClassifierFormDto, type BalanceReportFormatClassifierFormInterface } from '@zaoblako/shared/modules/finance/dtos/balance-report-format/balance-report-format-classifier-form.dto';

import * as yup from 'yup';

/** Balance report structure create and update request body */
export interface BalanceReportFormatFormInterface {
  /** Structure display name */
  name: string;
  /** Income classifiers */
  incomeClassifiers?: BalanceReportFormatClassifierFormInterface[];
  /** Expense classifiers */
  expenseClassifiers?: BalanceReportFormatClassifierFormInterface[];
}

export const BalanceReportFormatFormDto = SerdeDtoClass.create<BalanceReportFormatFormInterface>(
  FinanceDtoKeysEnum.BALANCE_REPORT_FORMAT_FORM_DTO,
  {
    name: {
      label: 'Название структуры',
      serializer: nonEmptyStringSchema,
    },
    incomeClassifiers: {
      optional: true,
      label: 'Классификаторы доходов',
      nested: BalanceReportFormatClassifierFormDto,
      serializer: (_, nested) => yup.array(nested),
    },
    expenseClassifiers: {
      optional: true,
      label: 'Классификаторы расходов',
      nested: BalanceReportFormatClassifierFormDto,
      serializer: (_, nested) => yup.array(nested),
    },
  },
);
